import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/vuex/store'
import Util from '@/assets/js/util'
import Icon from 'vue-svg-icon/Icon.vue'
import "amfe-flexible";
// import Vant from 'vant';

import '../../assets/css/reset.css'
// import 'vant/lib/index.css';
Vue.component('icon', Icon)
Vue.use(Util);


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
